export default __webpack_public_path__ + "2dbe4c5d4fdc8258a3e76484b79dddc7.jpg";